/**
 * Rating control module
 */
import { requestData } from "../utils";
import RateMessageRequest from "./RateMessageRequest";
import PriceRule from "./PriceRule";

export default class RatingModule {
  lookupMTPrice(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/rate_message/mt_price`, {
      ...rateMessageRequest,
    });
  }
  lookupMOPrice(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/rate_message/mo_price`, {
      ...rateMessageRequest,
    });
  }
  lookupMTPriceRule(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/matching_price_rule/mt_price`, {
      ...rateMessageRequest,
    });
  }
  lookupMOPriceRule(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/matching_price_rule/mo_price`, {
      ...rateMessageRequest,
    });
  }
  lookupMTCost(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/rate_message/mt_cost`, {
      ...rateMessageRequest,
    });
  }
  lookupMOCost(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/rate_message/mo_cost`, {
      ...rateMessageRequest,
    });
  }
  lookupMTMatrix(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/matching_price_rule/mt_cost`, {
      ...rateMessageRequest,
    });
  }
  lookupMOMatrix(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/matching_price_rule/mo_cost`, {
      ...rateMessageRequest,
    });
  }
  getMTRate(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/rate_message/mt`, {
      ...rateMessageRequest,
    });
  }
  getMORate(request) {
    const rateMessageRequest = new RateMessageRequest(request);
    return requestData("POST", `/rate_message/mo`, {
      ...rateMessageRequest,
    });
  }
  getBatchRateMT(requests) {
    const batch = [];
    requests.forEach((request) => {
      batch.push(new RateMessageRequest(request));
    });
    return requestData("POST", `/batch/rate_message/mt`, {
      messages: batch,
    });
  }
  getBatchRateMO(requests) {
    const batch = [];
    requests.forEach((request) => {
      batch.push(new RateMessageRequest(request));
    });
    return requestData("POST", `/batch/rate_message/mo`, {
      messages: batch,
    });
  }
  getPriceMT(query, abortSignal) {
    return requestData(
      "POST",
      `/provisioning/get_mt_price`,
      query,
      undefined,
      abortSignal
    );
  }
  getPriceMO(query, abortSignal) {
    return requestData(
      "POST",
      `/provisioning/get_mo_price`,
      query,
      undefined,
      abortSignal
    );
  }
  addPriceMT(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    let ruleQueryHeader = {};
    if (request.account_id) {
      ruleQueryHeader.account_id = request.account_id;
    }
    if (request.rating_group) {
      ruleQueryHeader.rating_group = request.rating_group;
    }
    return requestData("POST", `/provisioning/mt_price`, {
      ...ruleQueryHeader,
      rules: priceRules,
    });
  }
  addPriceMO(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    let ruleQueryHeader = {};
    if (request.account_id) {
      ruleQueryHeader.account_id = request.account_id;
    }
    if (request.rating_group) {
      ruleQueryHeader.rating_group = request.rating_group;
    }
    return requestData("POST", `/provisioning/mo_price`, {
      ...ruleQueryHeader,
      rules: priceRules,
    });
  }
  updatePriceMT(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    let ruleQueryHeader = {};
    if (request.account_id) {
      ruleQueryHeader.account_id = request.account_id;
    }
    if (request.rating_group) {
      ruleQueryHeader.rating_group = request.rating_group;
    }
    return requestData("PUT", `/provisioning/mt_price`, {
      ...ruleQueryHeader,
      rules: priceRules,
    });
  }
  updatePriceMO(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    let ruleQueryHeader = {};
    if (request.account_id) {
      ruleQueryHeader.account_id = request.account_id;
    }
    if (request.rating_group) {
      ruleQueryHeader.rating_group = request.rating_group;
    }
    return requestData("PUT", `/provisioning/mo_price`, {
      ...ruleQueryHeader,
      rules: priceRules,
    });
  }
  deletePriceMT(request) {
    const rules = request.rules.map((r) => new PriceRule(r));
    if (request.account_id) {
      rules[0].account_id = request.account_id;
    }
    return requestData("DELETE", `/provisioning/mt_price`, {
      rules,
    });
  }
  deletePriceMO(request) {
    const rules = request.rules.map((r) => new PriceRule(r));
    if (request.account_id) {
      rules[0].account_id = request.account_id;
    }
    return requestData("DELETE", `/provisioning/mo_price`, {
      rules
    });
  }
  /**product=${SMS|TTS|etc}
     &currency=${current-code}  (optional)
     &gateway=${gateway} (optional)
     &network=${network or comma separated list} (optional)
     &prefix=${msisdn prefix} (optional)
      */
  getCostMT(query) {
    return requestData("GET", `/provisioning/mt_cost`, query);
  }
  getCostMO(query) {
    return requestData("GET", `/provisioning/mo_cost`, query);
  }
  addCostMT(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    return requestData("POST", `/provisioning/mt_cost`, {
      gateway_id: request.gateway_id,
      rules: priceRules,
    });
  }
  addCostMO(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    return requestData("POST", `/provisioning/mo_cost`, {
      gateway_id: request.gateway_id,
      rules: priceRules,
    });
  }

  updateCostMT(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    return requestData("PUT", `/provisioning/mt_cost`, {
      gateway_id: request.gateway_id,
      rules: priceRules,
    });
  }
  updateCostMO(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    return requestData("PUT", `/provisioning/mo_cost`, {
      gateway_id: request.gateway_id,
      rules: priceRules,
    });
  }

  deleteCostMT(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    return requestData("DELETE", `/provisioning/mt_cost`, {
      gateway_id: request.gateway_id,
      rules: priceRules,
    });
  }
  deleteCostMO(request) {
    const priceRules = request.rules.map((priceRule) => new PriceRule(priceRule));
    return requestData("DELETE", `/provisioning/mo_cost`, {
      gateway_id: request.gateway_id,
      rules: priceRules,
    });
  }
}
